(ns teamoesterreich.ajax
  (:require
    [cljs.core.async :refer [<! put!]]
    [clojure.string :as str]
    [goog.json :as json]
    [goog.net.XhrIo :as xhr]))

(def log-out js/console.log)



(defn myCallback [replyValue]
  (log-out replyValue))


(defn serialize [in]
  (json/serialize (clj->js in)))

(defn un-serialize-path [in]
  (json/parse in))


(defn utf8encode [in]
  (str/replace (serialize in) #"^\"|\"$" ""))




(defn get>
  ([uri]
   (xhr/send uri (fn [e]
                   ;(log-out "got ajax response : " uri "  /" )
                   )))
  ([uri >data-ch]
   (xhr/send uri (fn [e]
                   ;(log-out "got ajax response : " uri "  / Etag=" (.getResponseHeader (.-target e) "Etag"))
                   (put! >data-ch {:body (.getResponse (.-target e))
                                   :etag (.getResponseHeader (.-target e) "Etag")}
                         ))
             "GET" nil #js {"Content-Type" "application/json"
                            })))


(defn get-with-header>
  ([uri headers]
   (xhr/send uri (fn [e]
                   ;(log-out "got ajax response : " uri "  /" )
                   )))
  ([uri headers >data-ch]
   (xhr/send uri (fn [e]
                   ;(log-out "got ajax response : " uri "  / Etag=" (.getResponseHeader (.-target e) "Etag"))
                   (put! >data-ch {:body (.getResponse (.-target e))
                                   :etag (.getResponseHeader (.-target e) "Etag")})
                   )
             "GET" nil (clj->js (merge {}
                                       headers)))))

(defn get>> [uri & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done! response " (.getResponse (.-target e)) (.getStatus (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "GET" nil #js {"Content-Type" "application/json"
                           }))


(defn post> [uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done! response " (.getResponse (.-target e)) (.getStatus (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "POST" blob #js {"Content-Type" "application/json"
                             }))
(defn put> [uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done!" (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "PUT" blob #js {"Content-Type" "application/json"
                            }))

(defn patch> [uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done!" (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "PATCH" blob #js {"Content-Type" "application/json"
                              }))

(defn delete> [uri & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "DELETE"))


(defn auth-get> [auth uri & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done! response " (.getResponse (.-target e)) (.getStatus (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "GET" nil (clj->js (merge {"Content-Type" "application/json"
                                       }
                                      (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                      ))
            ))


(defn auth-post> [auth uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done! response " (.getResponse (.-target e)) (.getStatus (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "POST" blob (clj->js (merge {"Content-Type" "application/json"
                                         }
                                        (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                        ))
            ))
(defn auth-put> [auth uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done!" (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "PUT" blob (clj->js (merge {"Content-Type" "application/json"
                                        }
                                       (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                       ))
            ))

(defn auth-patch> [auth uri blob & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done!" (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "PATCH" blob (clj->js (merge {"Content-Type" "application/json"
                                          }
                                         (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                         ))
            ))

(defn auth-delete> [auth uri & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)) (.getStatus (.-target e)))))
            "DELETE" nil (clj->js (merge {"Content-Type" "application/json"
                                          }
                                         (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                         ))
            ))



(defn post-file> [uri blob file-name content-type & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done! response " (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)))))
            "POST" blob #js {"Content-Type" content-type
                             "File-Name"    file-name
                             }))

(defn auth-post-file> [auth uri blob file-name content-type & [on-finished-fn]]
  (xhr/send uri (fn [e]
                  ;(log-out "done!" e)
                  ;(log-out "done! response " (.getResponse (.-target e)))
                  (when on-finished-fn (on-finished-fn (.getResponse (.-target e)))))
            "POST" blob (clj->js (merge {"Content-Type" content-type
                                         "File-Name"    (utf8encode file-name)
                                         }
                                        (when auth {"Authorization" (str (.-token_type auth) " " (.-access_token auth))})
                                        ))
            ))


;(post>)
